

export default (state = false, action) => {
    if (action.type === 'TOGGLE_SEARCH') {
        return action.payload
    }

    return state;
}